import { useTranslation } from "react-i18next";

/**
 * Resurs/amal ID (`role-assignments`, `read_document`) → foydalanuvchi tilidagi
 * nom (`roles.json` → `resourceNames`/`actionNames`).
 *
 * Tarjimasi yo'q nom (kelajakda backend'ga qo'shilgan resurs) xom ID bo'lib
 * ko'rinadi — sahifa buzilmaydi. Backend ro'yxati bilan to'liqlikni
 * `apps/backend/test/permission-labels.test.ts` qulflaydi.
 */
export function usePermissionLabels() {
	const { t } = useTranslation("roles");

	return {
		resourceLabel: (name: string) => t(`resourceNames.${name}`, { defaultValue: name }),
		actionLabel: (name: string) => t(`actionNames.${name}`, { defaultValue: name }),
	};
}
